import { DatoCmsFileField } from '@src/typings/dato-cms-assets'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import { SignupButton } from '../signup-button/SignupButton.component'
import styles from './FactQuoteBanner.module.scss'

export type FactQuoteBannerProps = {
  theme: 'purple' | 'dark'
  text: string
  cta: string
} & (
  | { logo?: 'default'; logoSvg?: DatoCmsFileField }
  | { logo: 'import'; logoSvg: DatoCmsFileField }
)

export function FactQuoteBanner({
  theme = 'purple',
  text,
  cta,
  logo = 'default',
  logoSvg,
}: FactQuoteBannerProps): ReactNode {
  const banner = classNames(styles.FactQuoteBanner, {
    [styles.FactQuoteBanner___dark]: theme === 'dark',
  })

  return (
    <section className={banner}>
      <img
        src={logo === 'default' ? '/icons/natural-cycles-logo.svg' : logoSvg?.url}
        alt="Natural Cycles"
      />
      <p>{text}</p>

      <div className={styles.FactQuoteBanner__cta}>
        <SignupButton isWide>{cta}</SignupButton>
      </div>
    </section>
  )
}
